import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

import { InformacionClienteModal } from "app/features/componentes/guia/informacionclientemodal"
import { FolioRadModal, RADModel } from "app/features/general/operativa/items/guias/listados/guias/list2/modal"

const EditModal = InformacionClienteModal;
const FolioRecModal = FolioRadModal;

type Entity = models.GuiaConsulta;
export interface Props {
    value: Entity[];
    hideBusqueda?: boolean;
    cookieKey?: string;
}

function obtenerServAdicionalesGuia(x: models.ServiciosAdicionalesGuiaDTO | null): string[] {
    if (!x) return [];

    const ret = [
        x.EntregaDomicilio ? "Entrega a domicilio" : undefined,
        x.RecoleccionDomicilio ? "Recolección a domicilio" : undefined,
        x.TipoAcuse == models.TipoAcuse.Interno ? "Acuse interno" : undefined,
        x.TipoAcuse == models.TipoAcuse.Externo ? `Acuse externo (${x.NombreRequerimientoAcuse})` : undefined,
    ];
    return ret.filter(x => x != null).map(x => x!);
}

export interface BotonesListaDeps {
    onVer: (x: Entity) => void;
    onRecolectar: (x: Entity) => void;
    onVerFirma: (x: Entity) => void;
    onImprimir: (x: Entity) => void;
    onCancelar: (x: Entity) => void;
    onNoFacturable: (x: Entity) => void;
    onReporteAcuse: (x: Entity) => void;
}

const columnasFijas: kea.Grid2Column<Entity>[] = [
    {
        title: "No. guia", cell: x => ({
            data: x.Folio, view: () =>
                <span style={{ fontFamily: "monospace" }} >
                    {x.Folio }
                    {
                        ( x.EsDeAcuse && " " && !x.EsGuiaPP ) && 
                        <span className="label label-danger" >ACU</span>
                    }
                    {
                        x.EsGuiaPP && " " &&
                        <span className="label label-primary" >PP</span>
                    }
                    {
                        x.EsGuiaZonaExtendida && " " && 
                        <span className="label label-warning" >ZE</span>
                    }
                </span>
        })
    },
    { title: "Factura", cell: x => ({ data: x.NoFacturable ? "No Facturable" : x.FolioFactura }) },

    { title: "PaquetePP", cell: x => ({ data: x.IdPaquetePP }) },

    { title: "Folio Manifiesto Rad", cell: x => ({ data: x.ManifiestoRAD }) },
    { title: "Status", cell: x => ({ data: models.StatusGuia[x.Status] }) },
    { title: "Sucursal actual", cell: x => ({ data: x.NombreSucursalStatus }) },
    { title: "Fecha creación", cell: x => ({ data: kea.toDate(x.FechaCreacion) }) },
    { title: "Sucursal origen", cell: x => ({ data: x.NombreSucursalOrigen }) },
    { title: "Origen", cell: x => ({ data: x.DireccionOrigen }) },
    { title: "Sucursal destino", cell: x => ({ data: x.NombreSucursalDestino }) },

    {
        title: "Cliente destino", cell: x => ({
            data: x.NombreClienteDestino, view: () =>
                <a href= { "/#/catalogos/Cliente/"+x.IdClienteDestino } >
                    <span title={x.NombreClienteDestino}>
                        {x.NombreClienteDestino}
                    </span>
                </a>
        })
    },

    { title: "Destino", cell: x => ({ data: x.DireccionDestino }) },
    { title: "Paquetes", cell: x => ({ data: x.CantidadPaquetes }) },
    { title: "Peso vol.", cell: x => ({ data: x.PesoVolumetrico }) },
    { title: "Peso (kg)", cell: x => ({ data: x.Peso }) },
    { title: "Volumen (M3)", cell: x => ({ data: (x.Volumen/1000000) }) },
    { title: "Paquetes (detalle)", cell: x => ({ data: (x.DescripcionPaquetesTexto || "").split(", ") }) },
    { title: "Sobres", cell: x => ({ data: x.CantidadSobres }) },
    { title: "Serv. adic.", cell: x => ({ data: obtenerServAdicionalesGuia(x.ServiciosAdicionales) }) },
    { title: "Importe total", cell: x => ({ data: x.ImporteTotal, view: kea.formatCurrency }) },
    { title: "Importe PP", cell: x => ({ data: x.ImporteGuiaPP, view: kea.formatCurrency }) },
    { title: "Importe total + PP", cell: x => ({ data: x.ImporteTotalConGuiaPP, view: kea.formatCurrency }) },

    { title: "Contacto recibio", cell: x => ({ data: x.NombreContactoRecibio }) },
    { title: "Folio acuse original", cell: x => ({ data: x.FolioGuiaAcuse }) },
    { title: "Fecha de entrega", cell: x => ({ data: kea.toDate(x.FechaEntrega) }) },
    { title: "Valor declarado", cell: x => ({ data: x.ValorDeclarado }) },
    { title: "Motivo rechazo público general", cell: x => ({ data: x.NoFacturable ? "No Facturable" : x.MotivoRechazoPublicoGeneral }) },
    { title: "Cancelada", cell: x => ({ data: x.EsCancelada }) },
    { title: "Documentó", cell: x => ({ data: x.NombrePersonaDocumento }) },
    { title: "Observaciones", cell: x => ({ data: (x.ObservacionesGuia || "").split("|") }) },
]

/**Obtiene las columnas del grid */
function columnas(deps: BotonesListaDeps, permisos: models.Rol): kea.Grid2Column<Entity>[] {
    const botones = kea.columnaBotones<Entity>([
        {
            onClick: x => deps.onVer(x),
            tooltip: "Ver",
            iconClass: fa("eye", "fw"),
        },{
            onClick: x => deps.onRecolectar(x),
            tooltip: "Marcar guia como recolectada",
            disabled: x => x.Status != models.StatusGuia.RecoleccionPendiente ,
            iconClass: fa("home", "fw")
        }, {
            onClick: x => deps.onImprimir(x),
            tooltip: "Imprimir",
            iconClass: fa("print", "fw")
        }, {
            onClick: x => deps.onReporteAcuse(x),
            disabled: x => !x.PuedeImprimirAcuseInterno,
            tooltip: "Imprimir acuse interno",
            iconClass: fa("file-o", "fw")
        }, {
            onClick: x => deps.onCancelar(x),
            disabled: x => !permisos.Guia.VerBotonCancelarGuia || 
            ( x.IdSucursalOrigen == x.IdSucursalDestino ?
                 x.Status != models.StatusGuia.EnSucursalOrigen && x.Status != models.StatusGuia.RecoleccionPendiente &&x.Status != models.StatusGuia.EnSucursalDestino : 
                 x.Status != models.StatusGuia.EnSucursalOrigen && x.Status != models.StatusGuia.RecoleccionPendiente
            ) ,
            tooltip: "Cancelar guia",
            iconClass: fa("times-circle-o", "fw")
        }, {
            onClick: x => deps.onNoFacturable(x),
            disabled: x => !permisos.Guia.VerBotonMarcarGuiaNoFacturable,
            tooltip: "Marcar guia como no facturable",
            iconClass: fa("xing-square", "fw")
        }, {
            onClick: x => deps.onVerFirma(x),
            disabled: x => !permisos.Rastreo.VerBotonInformacionCliente || 
            (
                x.Status != models.StatusGuia.EntregadaOcurre 
                && x.Status != models.StatusGuia.EntregadaDomicilio
                && x.Status != models.StatusGuia.EntregadaZonaExtendida
            ),
            tooltip: "Ver firma del cliente",
            iconClass: fa("pencil-square-o", "fw")
        }
    ]);

    const columnasFijas2: kea.Grid2Column<Entity>[] = [
        {
            title: "No. guia", cell: x => ({
                data: x.Folio, view: () =>
                    <span style={{ fontFamily: "monospace" }} >
                        {x.Folio }
                        {
                            ( x.EsDeAcuse && " " && !x.EsGuiaPP ) && 
                            <span className="label label-danger" >ACU</span>
                        }
                        {
                            x.EsGuiaPP && " " &&
                            <span className="label label-primary" >PP</span>
                        }
                        {
                            x.EsGuiaZonaExtendida && " " && 
                            <span className="label label-warning" >ZE</span>
                        }
                    </span>
            })
        },
        { title: "Factura", cell: x => ({ data: x.NoFacturable ? "No Facturable" : x.FolioFactura }) },
        { title: "PaquetePP", cell: x => ({ data: x.IdPaquetePP}) },

        { title: "Folio Manifiesto Rad", cell: x => ({ data: x.ManifiestoRAD }) },
        { title: "Status", cell: x => ({ data: models.StatusGuia[x.Status] }) },
        { title: "Sucursal actual", cell: x => ({ data: x.NombreSucursalStatus }) },
        { title: "Fecha creación", cell: x => ({ data: kea.toDate(x.FechaCreacion) }) },
        { title: "Sucursal origen", cell: x => ({ data: x.NombreSucursalOrigen }) },
    
        
            {
                title: "Nombre cliente origen", cell: x => ({
                    data: x.NombreClienteOrigen, view: () =>
                    permisos.Catalogos.Cliente.EditarDesdeListadoGuias ? 
                        <a href= { "/#/catalogos/Cliente/"+x.IdClienteOrigen } >
                            <span title={x.NombreClienteOrigen}>
                                {x.NombreClienteOrigen}
                            </span>
                        </a>
                    :
                        <span title={x.NombreClienteOrigen}>
                            {x.NombreClienteOrigen}
                        </span>
                })
            }
        ,
    
        { title: "Dirección del cliente origen", cell: x => ({ 
            data: x.DireccionOrigen, view: () =>
                <span title={x.DireccionOrigen}>
                    {x.DireccionOrigen}
                </span>
        }) },
        { title: "Sucursal destino", cell: x => ({ data: x.NombreSucursalDestino }) },
    
        {
            title: "Nombre cliente destino", cell: x => ({
                data: x.NombreClienteDestino, view: () =>
                permisos.Catalogos.Cliente.EditarDesdeListadoGuias ? 
                    <a href= { "/#/catalogos/Cliente/"+x.IdClienteDestino } >
                        <span title={x.NombreClienteDestino}>
                            {x.NombreClienteDestino}
                        </span>
                    </a>
                :
                    <span title={x.NombreClienteDestino}>
                        {x.NombreClienteDestino}
                    </span>
            })
        }
        ,
        { title: "Dirección del cliente Destino", cell: x => ({ 
            data: x.DireccionDestino, view: () =>
                <span title={x.DireccionDestino}>
                    {x.DireccionDestino}
                </span>
        }) },
        { title: "Paquetes", cell: x => ({ data: x.CantidadPaquetes }) },
        { title: "Peso vol.", cell: x => ({ data: x.PesoVolumetrico }) },
        { title: "Peso (kg)", cell: x => ({ data: x.Peso }) },
        //{ title: "Volumen (cm3)", cell: x => ({ data: x.Volumen }) },
        { title: "Volumen (M3)", cell: x => ({ data: (x.Volumen/1000000) }) },
        { title: "Paquetes (detalle)", cell: x => ({ data: (x.DescripcionPaquetesTexto || "").split(", ") }) },
        { title: "Sobres", cell: x => ({ data: x.CantidadSobres }) },
        { title: "Serv. adic.", cell: x => ({ data: obtenerServAdicionalesGuia(x.ServiciosAdicionales) }) },
        { title: "Importe total", cell: x => ({ data: x.ImporteTotal, view: kea.formatCurrency }) },
        { title: "Importe PP", cell: x => ({ data: x.ImporteGuiaPP, view: kea.formatCurrency }) },
        { title: "Importe total + PP", cell: x => ({ data: x.ImporteTotalConGuiaPP, view: kea.formatCurrency }) },

        { title: "flete sin descuento", cell: x => ({ data: x.ImportesValores.FleteSinDescuento, view: kea.formatCurrency }) },
        { title: "zona extendida", cell: x => ({ data: x.ImportesValores.ZonaExtendida, view: kea.formatCurrency }) },
        { title: "seguro", cell: x => ({ data: x.ImportesValores.Seguro, view: kea.formatCurrency }) },
        { title: "ead", cell: x => ({ data: x.ImportesValores.EntregaDomicilio, view: kea.formatCurrency }) },
        { title: "rad", cell: x => ({ data: x.ImportesValores.RecoleccionDomicilio, view: kea.formatCurrency }) },
        { title: "servicio especial", cell: x => ({ data: x.ImportesValores.ServicioEspecial, view: kea.formatCurrency }) },
        { title: "iva", cell: x => ({ data: x.ImportesValores.Iva, view: kea.formatCurrency }) },
        { title: "ret", cell: x => ({ data: x.ImportesValores.RetencionIva, view: kea.formatCurrency }) },
        { title: "Flete compuesto", cell: x => ({ data: ( x.ImportesValores.FleteSinDescuento+ x.ImportesValores.ZonaExtendida + x.ImportesValores.ServicioEspecial ), view: kea.formatCurrency }) },
    
        { title: "Contacto recibio", cell: x => ({ data: x.NombreContactoRecibio }) },
        { title: "Folio acuse original", cell: x => ({ data: x.FolioGuiaAcuse }) },
        { title: "Fecha de entrega", cell: x => ({ data: kea.toDate(x.FechaEntrega) }) },
        { title: "Valor declarado", cell: x => ({ data: x.ValorDeclarado }) },
        { title: "Motivo rechazo público general", cell: x => ({ data: x.NoFacturable ? "No Facturable" : x.MotivoRechazoPublicoGeneral }) },
        { title: "Cancelada", cell: x => ({ data: x.EsCancelada }) },
        { title: "Documentó", cell: x => ({ data: x.NombrePersonaDocumento }) },
        { title: "Observaciones", cell: x => ({ data: (x.ObservacionesGuia || "").split("|") }) },
    ]

    return [
        botones,
        ...columnasFijas2
    ];
}

/**
* Listado de 
*/
class GuiasListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();

    permisos = (x: Props) => resources.User.PermisoRx;

    columnas = createSelectorRx(this.permisos, permisos => columnas(this, permisos));

    onRecolectar = async (x: Entity) => {
        debugger;
        const result = await this.modals.showModal(FolioRadModal, undefined, { } as RADModel);

        await resources.Guia.RecolectarGuiaSinValidarFolio(x.IdRegistro, result.value.folioRecoleccion  );
            await kea.message("El status de la guia "+ x.Folio +" ahora es en sucursal origen");
            location.reload();
    }

    onVer = async (x: Entity) => {
        await history.go("/operativa/guias/" + x.Folio);
    }

    onVerFirma = async (x: Entity) => {
        var guia = x
        var informacion = await resources.Rastreo.ObtenerInformacionCliente(guia.Folio);
        const result = await this.modals.showModal(EditModal, undefined, informacion);
    }

    onImprimir = async (x: Entity) => {
        const data = await resources.Guia.ReporteGuia(x.Folio);
        kea.printPdf(data);
    }

    onCancelar = async (x: Entity) => {
        if (await kea.yesno("¿Seguro que desea cancelar esta guia?")) {
            await resources.Guia.CancelarGuia(x.Folio);
            await kea.message("La guía fue cancelada");
        }
    }

    onNoFacturable = async (x: Entity) => {
        if (await kea.yesno("¿Seguro que desea marcar esta guía como no facturable?")) {
            await resources.Guia.MarcarGuiaNoFacturable(x.Folio);
            await kea.message("La guía fue marcada como no facturable");
        }
    }

    onReporteAcuse = async (x: Entity) => {
        console.log(x);
        
        const data = await resources.Guia.ReporteAcuse(x.Folio);
        await kea.download(kea.base64ToBlob((data)), "Acuse de recibo de " + x.Folio + ".pdf");
    }

    render() {
        const permisos = this.permisos(this.props);
        const cols = this.columnas(this.props);

        return (
            <div>
                <kea.Grid2 items={this.props.value} columnas={cols} hideBusqueda={this.props.hideBusqueda} cookieKey={this.props.cookieKey} />
                {this.modals.component}
            </div>
        );
    }
}
/**Listado de las guias en memoria */
export const GuiaListMem = kea.mapProps(componentToRx(GuiasListNoRx), x => ({ ...x, value: x.value || [] }));


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/listados/guias/list2/listmem.tsx